module.exports = __webpack_public_path__ + "static/media/Fallen1.b22c5f30.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/Characters/Fallen1.jpg
// module id = 190
// module chunks = 0